<template>
    <div class="video">
        <!-- 使用组件
        增加loading，优化视频播放缓慢问题
      -->
      <video-player class="video-player"
        ref="videoPlayer"
        v-loading="loading"
        element-loading-background="rgb(0,0,0)"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>
  </template>

<script>
export default {
  props: {
    mp4Url: {
      type: String,
      // default: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4'
      default: 'https://spark-school.oss-cn-beijing.aliyuncs.com/video/courseVideo/05190e91-3540-4ba9-bd49-e828c9a8361f.mp4'
    },
    mp4Pic: {
      type: String,
      // default: 'https://i.loli.net/2019/06/06/5cf8c5d9c57b510947.png'
      default: ''
    },
    // fileAreaHeight: {
    //   type: Number,
    //   default: 500
    // },
    fileType: {
      type: String,
      default: 'mp4' // 资源的类型
    }
  },
  computed: { // 使用计算属性
    playerOptions () {
      return {
        controls: true,
        playbackRates: [0.5, 0.75, 1.0, 1.25, 1.5, 2.0],
        autoplay: true,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/' + this.fileType,
          src: this.mp4Url
        }],
        poster: this.mp4Pic,
        notSupportedMessage: '此视频暂无法播放...',
        controlBar: {
          playToggle: true,
          volumePanel: { inline: true },
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          progressControl: true,
          playbackRateMenuButton: true,
          fullscreenToggle: true
        }
      };
    }
  },
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    this.$refs.videoPlayer.$refs.video.addEventListener('loadeddata', e => {
      console.log('提示视频的元数据已加载')
      console.log(e)
      this.loading = false;
    })
  },
  methods: {
    loadstart(e) {
      console.log('提示视频的元数据已加载', e)
    }
  },
};
</script>

<style lang="scss" scoped>
.video-player {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
}
::v-deep {
  .video-js {
    .vjs-big-play-button {
      width: 1.5em;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border: none;
    }
    .vjs-play-progress:before {
      font-size: 1em;
      top: 50%;
      transform: translateY(-50%);
    }
    .vjs-slider-horizontal .vjs-volume-level:before {
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>